import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import { UndoTwoTone, PrintTwoTone, Settings} from '@material-ui/icons';
import {Paper, Grid, Typography, IconButton, Button, Tooltip} from '@material-ui/core';
import ReactToPrint from 'react-to-print';

export default class ViewTMReport extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            tm_avail: [],
            error: false,
            error_message: '',
            querying: true,
            show_report: false,
            current_record : {},
            tm_data : {},
            block : 'C3',
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        };

    }

    componentDidMount = () => {
        this.setState({
            current_record:this.props.current_record,
            show_report:true,
            querying: true,
            tm_data: {},
            block: 'C3'
        });

        Gserv.sendCommand('query_tm_data',this.props.gwt,
        {
            assessee_id: this.props.current_record.assessee_id,
            cycle_id: this.props.current_record.cycle_id
        })
        .then(tm_data => {
            // console.log('tm_data :>> ', tm_data);
            if (tm_data.error){
                console.log('error on return from Gserv (tm_extract) :>> ', tm_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (tm_data.Result!=="Success"){
                console.log('error on return from Gserv (tm_extract) :>> ', tm_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                let perf_num = '3';
                let pm_symbol = 'C';
                const kpi = Number(tm_data.Record.KPI.key_datapoint_score_override? tm_data.Record.KPI.key_datapoint_score_override : tm_data.Record.KPI.key_datapoint_score);
                if (kpi>=90){perf_num = '2'}
                if (kpi>=100){perf_num = '1'}
                const pm = Number(tm_data.Record.PM.key_datapoint_score_override? tm_data.Record.PM.key_datapoint_score_override : tm_data.Record.PM.key_datapoint_score);
                if (pm === 2){
                    pm_symbol = 'B';
                } else if (pm === 3) {
                    pm_symbol = 'A';
                }
                this.setState({
                    tm_data: tm_data.Record,
                    block: pm_symbol + perf_num,
                    querying:false
                });
            }
        }); 

    };

    backToParent = () => {
        this.props.closeChild();
    }    

    render() {
        const current_record = this.props.current_record;

        return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            <Grid item>
            
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:825,
                        padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.backToParent}><UndoTwoTone /></IconButton></Tooltip>

                    <Tooltip title="Print or save as .pdf">
                        <span>
                        <ReactToPrint
                            content={() => this.componentRef}
                            bodyClass={'printSpecs'}
                            pageStyle={''}
                            trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                        />
                        </span>
                    </Tooltip>

                </Paper>

                <div id='Print Delimiter' 
                    ref={(response) => (this.componentRef = response)}
                >        

                <div
                    style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    
                >
                    <Typography color='primary' variant='h6'>Talent Matrix Report</Typography>
                    <Typography>For : <b>{current_record.name}</b> (Empl.# {current_record.assessee_id}) for cycle <b>{current_record.cycle_code}</b></Typography>
                    <Typography>{current_record.job_title} [<b>{current_record.store_code}</b>] Reporting to Manager: <b>{current_record.reports_to_rom}</b></Typography>
                    <Typography>Generated : {new Date().toDateString()}</Typography>
                </div>

                {this.state.querying&&
                <Typography
                    style={{marginTop:25}}
                >
                    <Settings className='icn-spinner' /><br/>
                    Extracting report data...
                </Typography>}

                {!this.state.querying&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'blue',
                        width:825,
                        padding:15
                    }}
                >
                <table>
                <tbody>
                    <tr>
                        <td colSpan={2} rowSpan={2}>
                            <Grid container direction='column' alignItems='center'>
                            <Grid 
                                container
                                direction='row'
                                justifyContent='center'
                                alignContent='center'
                            >
                                <Typography
                                    variant='h6'
                                >
                                    Classification:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                    variant='h6'
                                >
                                    {this.state.block}
                                </Typography>
                            </Grid>
                            <Grid 
                                container
                                direction='row'
                                justifyContent='center'
                                alignItems='center'
                                style={{
                                    borderWidth:1,
                                    borderStyle:'dashed',
                                    borderColor:'#bcbec0',
                                    width:'90%'
                                }}
                            >
                                <Typography>
                                    KPI Score:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                >
                                    {this.state.tm_data.KPI.key_datapoint_score_override? this.state.tm_data.KPI.key_datapoint_score_override : this.state.tm_data.KPI.key_datapoint_score}%
                                </Typography>
                                &nbsp;&nbsp;
                                <Typography>
                                    PM Rating:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                >
                                    {Number(this.state.tm_data.PM.key_datapoint_score_override? this.state.tm_data.PM.key_datapoint_score_override : this.state.tm_data.PM.key_datapoint_score)}
                                </Typography>
                            </Grid>
                            </Grid>
                        </td>
                        {/* <td></td> */}
                        <td colSpan={3}>
                            <Typography>&gt;&gt;&nbsp;&nbsp;POTENTIAL&nbsp;&nbsp;&gt;&gt;</Typography>
                            <hr/>
                        </td>
                    </tr>
                    <tr>
                        {/* <td>hello</td> */}
                        {/* <td>world</td> */}
                        <td>
                            <Typography style={{textAlign: 'center'}}>LOW POTENTIAL</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>STRONG</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>HIGH POTENTIAL</Typography>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={3}
                            style={{borderRight: '2px #bcbec0', borderRightStyle:'inset'}}
                        >
                            <Typography
                                className='verticalText'
                            >
                                &gt;&gt;&nbsp;&nbsp;PERFORMANCE&nbsp;&nbsp;&gt;&gt;
                            </Typography>
                        </td>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                EXCEPTIONAL / ABOVE TARGET / ROLE MODEL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='C1'? 'yellow': 'white',border: this.state.block==='C1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>C1</b>
                                <br/> 
                                HIGH PERFORMANCE / LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor:this.state.block==='B1'?'green':'white',border: this.state.block==='B1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='B1'? 'whitesmoke' : ''}}
                                
                            >
                                <b>B1</b>
                                <br/>
                                HIGH PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>    
                        </td>
                        <td style={{backgroundColor:this.state.block==='A1'? 'green' : 'white',border: this.state.block==='A1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='A1'? 'whitesmoke' : ''}}
                            >
                                <b>A1</b>
                                <br/>
                                HIGH PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                SOLID / ON TARGET
                            </Typography>        
                        </td>
                        <td style={{backgroundColor:this.state.block==='C2'? 'red' : 'white',border: this.state.block==='C2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='C2'? 'wheat' : ''}}
                            >
                                <b>C2</b>
                                <br/>
                                SOLID PERFORMANCE / LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='B2'? 'yellow' : 'white',border: this.state.block==='B2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>B2</b>
                                <br/>
                                SOLID PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='A2'? 'green' : 'white',border: this.state.block==='A2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='A2'? 'whitesmoke' : ''}}
                            >
                                <b>A2</b>
                                <br/>
                                SOLID PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                DEVELOPMENT NEEDED / BELOW TARGET / BELOW EXPECTATIONS
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='C3'? 'red' : 'white',border: this.state.block==='C3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='C3'? 'wheat' : ''}}
                            >
                                <b>C3</b>
                                <br/>
                                LOW PERFORMANCE &amp; LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='B3'? 'red' : 'white',border: this.state.block==='B3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='B3'? 'wheat' : ''}}
                            >
                                <b>B3</b>
                                <br/>
                                LOW PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='A3'? 'yellow' : 'white',border: this.state.block==='A3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>A3</b>
                                <br/>
                                LOW PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                </tbody>
            </table>
            </Paper>
            </Grid>}

            </div> 

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1150,maxWidth:1150, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.backToParent}>Back</Button>}
            </Grid>

        </Grid>
    )}
}